import styled from "styled-components";
import {
  color,
  layer,
  spacing,
  elevation,
  borderRadius,
} from "@conserveit/blocks";

function openClose({ isOpen }) {
  return isOpen ? "block" : "none";
}
export const ToolTip = styled.div`
  display: ${openClose};
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 auto;
  width: 100%;
  height: 1px;
  background: ${color.pureWhite};
  overflow: visible;
  z-index: ${layer.contextNavigation};
`;
export const Tip = styled.div`
  height: auto;
  max-height: 400px;
  max-width: 300px;
  min-width: 240px;
  border-radius: ${borderRadius.default};
  z-index: ${layer.contextNavigation};
  padding: ${spacing.default};
  background: ${color.pureWhite};
  box-shadow: ${elevation.contentNavigation};
  overflow: auto;
  transform: translate(-25%, -100%);
  cursor: default;
`;

export const TipWrapper = styled.span`
  position: relative;
  display: inline-block;
`;

export const TipRow = styled.div`
  margin-bottom: ${spacing.extraTight};
  font-size: 12px;
  font-weight: 400;
`;

export const TipTitle = styled(TipRow)`
  margin-bottom: ${spacing.tight};
  font-weight: 700;
`;

export const Heavy = styled.strong`
  display: block;
  font-size: 14px;
  text-decoration: underline dashed;
  text-underline-position: under;
  margin-bottom: ${spacing.extraTight};
`;
